import { ComparisonOperator, TextOperator } from "../menu/types";

export const TEXT_OPERATOR_LABEL_KEYS: Record<TextOperator, string> = {
  eq: "textOperatorIs",
  neq: "textOperatorIsNot",
  in: "textOperatorIsAnyOf",
  not_in: "textOperatorIsNotAnyOf",
};

export const DATE_OPERATOR_LABEL_KEYS: Record<ComparisonOperator, string> = {
  eq: "dateOperatorEq",
  gt: "dateOperatorGt",
  gte: "dateOperatorGte",
  lt: "dateOperatorLt",
  lte: "dateOperatorLte",
};

export const NUMERIC_OPERATOR_LABEL_KEYS: Record<ComparisonOperator, string> = {
  eq: "numericOperatorEq",
  gt: "numericOperatorGt",
  gte: "numericOperatorGte",
  lt: "numericOperatorLt",
  lte: "numericOperatorLte",
};

export function getTextOperatorOptions(
  hasMultipleValues: boolean,
): { operator: TextOperator; labelKey: string }[] {
  if (hasMultipleValues) {
    return [
      { operator: "in", labelKey: "textOperatorIsAnyOf" },
      { operator: "not_in", labelKey: "textOperatorIsNotAnyOf" },
    ];
  }
  return [
    { operator: "eq", labelKey: "textOperatorIs" },
    { operator: "neq", labelKey: "textOperatorIsNot" },
  ];
}
